export default "__VITE_ASSET__BIthA5At__"